import "@mdi/font/css/materialdesignicons.css";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import { useI18n } from "vue-i18n";
import "vuetify/styles";
import { createVuetify as createVuetifyFromLib } from "vuetify";

/**
 * https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
 * @param {import("vue-i18n").I18n} i18n
 * @returns {import("vue").Plugin}
 */
export function createVuetifyInstance(i18n) {
  return createVuetifyFromLib({
    theme: {
      defaultTheme: "light",
      themes: {
        light: {
          dark: false,
          colors: {
            primary: "#716ACA",
            "link-primary": "#716ACA",
            "text-primary": "#716ACA",
            "on-primary": "#FFFFFF",
            secondary: "#00bea5",
            "link-secondary": "#00bea5",
            "text-secondary": "#00bea5",
            "on-secondary": "#FFFFFF",
            accent: "#3545EE",
            "link-accent": "#716ACA",
            "text-accent": "#716ACA",
            "on-accent": "#FFFFFF",
            error: "#d93125",
            warning: "#e36c00",
            info: "#008ac8",
            success: "#019002",
            background: "#F2F3F8",
            header: "#FBFBFD",
            footer: "#A6ADB4",
            "on-footer": "#FFFFFF",
            third: "#ebeded",
          },
        },
      },
    },
    locale: {
      adapter: createVueI18nAdapter({ i18n, useI18n }),
    },
    defaults: {
      VAppBar: {
        density: "comfortable",
      },
      VTextField: {
        density: "comfortable",
        variant: "outlined",
      },
      VNumberInput: {
        density: "comfortable",
        variant: "outlined",
      },
      VSelect: {
        density: "comfortable",
        variant: "outlined",
        persistentHint: true,
      },
      VSwitch: {
        color: "secondary",
        density: "comfortable",
        variant: "outlined",
        hideDetails: "auto",
        persistentHint: true,
      },
      VRadio: {
        density: "comfortable",
        variant: "outlined",
        hideDetails: "auto",
        persistentHint: true,
      },
      VCheckbox: {
        density: "comfortable",
        variant: "outlined",
        hideDetails: "auto",
        persistentHint: true,
      },
      VTextarea: {
        density: "comfortable",
        variant: "outlined",
      },
      VFileInput: {
        density: "comfortable",
        variant: "outlined",
      },
      VAutocomplete: {
        density: "comfortable",
        variant: "outlined",
        persistentHint: true,
      },
      VCombobox: {
        density: "comfortable",
        variant: "outlined",
        persistentHint: true,
      },
      VChip: {
        density: "comfortable",
        variant: "flat",
      },
      VBtn: {
        color: "secondary",
        variant: "elevated",
        rounded: "xl",
        VIcon: {
          size: "large",
        },
      },
      VCardActions: {
        VBtn: {
          color: "secondary",
          variant: "elevated",
          rounded: "xl",
          VIcon: {
            size: "large",
          },
        },
      },
      VCard: {
        rounded: "lg",
      },
      VList: {
        density: "comfortable",
        lines: "one",
      },
      VListItem: {
        density: "comfortable",
      },
      VAlert: {
        density: "comfortable",
      },
      VDialog: {
        width: "98%",
        maxWidth: "600",
      },
      VTooltip: {
        color: "white",
      },
      VToolbar: {
        density: "comfortable",
      },
      VDatePicker: {
        showAdjacentMonths: true,
      },
      VDataTable: {
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 25, 50, 100],
        mobile: null,
        mobileBreakpoint: "md",
      },
      VDataTableServer: {
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 25, 50, 100],
        mobile: null,
        mobileBreakpoint: "md",
      },
      VDataTableVirtual: {
        mobile: null,
        mobileBreakpoint: "md",
      },
      VTable: {
        mobile: null,
        mobileBreakpoint: "md",
        density: "comfortable",
      },
      VBtnToggle: {
        density: "comfortable",
        rounded: "0",
        tile: true,
        class: "flex-wrap",
      },
      VBtnGroup: {
        density: "comfortable",
        rounded: "0",
        tile: true,
        class: "flex-wrap",
        VBtn: {
          variant: "outlined",
          rounded: "0",
          class: "text-none mb-1",
          selectedClass: "btn-underlined v-btn--variant-tonal",
        },
      },
    },
  });
}
